<template>
  <div class="greeting-container">
    <div class="greeting-card">
      <i :class="timeOfDayIcon" class="time-icon"></i>
      <div class="greeting-text">
        <h1>{{ greetingMessage }}, {{ userName }}!</h1>
        <p v-if="quote">{{ quote }}</p>
      </div>
      <button @click="navigateToOnboarding" class="button" style="margin-top: 20px;">Start Onboarding</button>
      <button @click="logout" class="button" style="display: block; margin-top: 20px;">Log Out</button>
    </div>
  </div>
</template>

<script>
import { Auth } from 'aws-amplify';
import axios from 'axios';

export default {
  data() {
    return {
      userName: '', 
      quote: '', 
    };
  },
  computed: {
    timeOfDay() {
      const hour = new Date().getHours();
      return hour < 12 ? 'morning' : hour < 18 ? 'afternoon' : 'evening';
    },
    greetingMessage() {
      return `Good ${this.timeOfDay}`;
    },
    timeOfDayIcon() {
      const icons = {
        morning: 'fa-sun',
        afternoon: 'fa-cloud-sun',
        evening: 'fa-moon',
      };
      return `fas ${icons[this.timeOfDay]}`;
    },
  },
  methods: {
    async getQuoteFromAPI() {
      const randomId = Math.floor(Math.random() * 110) + 1;
      try {
        const response = await axios.get(`https://api.riskypaws.com/backoffice/api/quote/${randomId}/`);
        this.quote = response.data.text;
      } catch (error) {
        console.error('Error fetching quote:', error);
        this.quote = '"In nine lifetimes, you will never know as much about your cat as your cat knows about you." - Michel de Montaigne';
      }
    },
    async fetchUserName() {
      try {
        const user = await Auth.currentAuthenticatedUser();
        this.userName = user.attributes.name;
      } catch (error) {
        console.error('Error fetching user information:', error);
      }
    },
    async logout() {
      try {
        await Auth.signOut();
        this.$router.push('/login');
      } catch (error) {
        console.error('error signing out: ', error);
      }
    },
    navigateToOnboarding() {
      this.$router.push('/onboarding');
    },
  },
  created() {
    this.getQuoteFromAPI();
    this.fetchUserName();
  },
}
</script>

<style scoped>
.greeting-container {
  display: flex;
  justify-content: center;
  width: 100%;
}

.greeting-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px;
  background-color: #f5f5f5;
  border-radius: 10px;
  margin: 20px 0;
  width: 100%;
}

.greeting-text {
  flex-grow: 1;
}

.time-icon {
  font-size: 2rem;
  margin-right: 20px;
}

h1 {
  margin: 0;
  color: #333;
}

p {
  margin: 0;
  color: #666;
}

.logout-button {
  background-color: #4A148C;
  color: white;
  padding: 10px 20px;
  border-radius: 5px;
  text-decoration: none;
  transition: background-color 0.3s ease;
}

.logout-button:hover {
  background-color: #6C1B9A;
}

@media (max-width: 768px) {
  .time-icon {
    font-size: 1.5rem;
  }
  
  h1 {
    font-size: 1.2rem;
  }
  
  p {
    font-size: 0.8rem;
  }
  
  .button {
  background-image: linear-gradient(135deg, #6D5BBA 0%, #8D58BF 100%); /* Apply the same gradient as your app theme */
  color: white;
  border: none;
  padding: 10px 15px;
  border-radius: 5px;
  margin: 5px;
  cursor: pointer;
  transition: background-color 0.3s, box-shadow 0.3s;
}
.button:hover {
  background-image: linear-gradient(135deg, #8D58BF 0%, #6D5BBA 100%); /* Slightly adjust gradient for hover effect */
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2); /* Add a shadow for depth */
}
}
</style>